import User from '../../models/User'

export const USER_FETCHED = 'USER_FETCHED'
export const USER_LOADED = 'USER_LOADED'

export const userFetched = user => ({
  type: USER_FETCHED,
  user
})

export const userLoaded = () => ({
  type: USER_LOADED
})

export function fetchCurrentUser() {
  return dispatch => {
    User.getCurrentUser()
      .then(res => {
        dispatch(userFetched(res))
        dispatch(userLoaded())
      })
      .catch(e => {
        dispatch(userLoaded())
      })
  }
}
